export default {
    rules(state) {
        return state.rules
    }
};
